import { Label, Text } from "react-aria-components";
import {
  StyledCheckbox,
  StyledCheckboxGroup,
  StyledIndicator,
  StyledCheckboxIcon,
} from "./checkbox.style";
import { MDSCheckboxProps, MDSCheckboxGroupProps, MDSCheckboxSlotName } from "./checkbox.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import { MDSIconColor, MDSIconKind } from "@/mds/components/icon";

export const MDSCheckbox = ({ children, value, ...props }: MDSCheckboxProps) => {
  return (
    <StyledCheckbox {...props} value={value}>
      {({ isSelected, isIndeterminate }) => (
        <>
          <StyledIndicator>
            <StyledCheckboxIcon
              kind={
                isIndeterminate
                  ? MDSIconKind.CheckboxIndeterminate
                  : isSelected
                    ? MDSIconKind.CheckboxSolid
                    : MDSIconKind.CheckboxEmpty
              }
              color={isSelected || isIndeterminate ? MDSIconColor.Selected : MDSIconColor.Secondary}
              boxSize={16}
              size={16}
            />
          </StyledIndicator>
          <Label>{children}</Label>
        </>
      )}
    </StyledCheckbox>
  );
};

export const MDSCheckboxGroup = ({
  children,
  label,
  description,
  errorMessage,
  ...props
}: MDSCheckboxGroupProps) => {
  return (
    <StyledCheckboxGroup {...props}>
      {label && <Label>{label}</Label>}
      {description && <Text slot="description">{description}</Text>}
      {getSlot(children, MDSCheckboxSlotName.Before)}
      {getUnslottedChildren(children)}
      {getSlot(children, MDSCheckboxSlotName.After)}
      {errorMessage && <Text slot="errorMessage">{errorMessage}</Text>}
    </StyledCheckboxGroup>
  );
};
